/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Travel_EventsInputs */

const en_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel & Events`)
};

const es_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viajes y Eventos`)
};

const fr_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyages et Événements`)
};

const de_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reisen & Events`)
};

const ja_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行＆イベント`)
};

const zh_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行与活动`)
};

const ar_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السفر والأحداث`)
};

const id_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perjalanan & Acara`)
};

const it_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viaggi & Eventi`)
};

const ru_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путешествия и События`)
};

const pt_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viagens e Eventos`)
};

const ko_travel_events = /** @type {(inputs: Travel_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여행 및 이벤트`)
};

/**
* | output |
* | --- |
* | "Travel & Events" |
*
* @param {Travel_EventsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const travel_events = /** @type {((inputs?: Travel_EventsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Travel_EventsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_travel_events(inputs)
	if (locale === "es") return es_travel_events(inputs)
	if (locale === "fr") return fr_travel_events(inputs)
	if (locale === "de") return de_travel_events(inputs)
	if (locale === "ja") return ja_travel_events(inputs)
	if (locale === "zh") return zh_travel_events(inputs)
	if (locale === "ar") return ar_travel_events(inputs)
	if (locale === "id") return id_travel_events(inputs)
	if (locale === "it") return it_travel_events(inputs)
	if (locale === "ru") return ru_travel_events(inputs)
	if (locale === "pt") return pt_travel_events(inputs)
	return ko_travel_events(inputs)
});